<template>
    <div class="ancestor">
        <div class="theme-titles">
            <div class="theme-text">
                <img src="~assets/image/solution-img/resolve.png" />
                <span class="theme-name">解决方案</span>
                <span class="boult">&gt;</span>
            </div>
        </div>
        <div class="header">
            <div>
                <p>我公司提供带芯片RFID共享托盘可供选择，并将基于RFID托盘定制高效率低误差的仓库储物流解决方案，为客户的仓储物流管理节约成本、降低损耗。</p>
            </div>
        </div>
        <div class="sortware">
            <!-- 软件技术结构 -->
            <div class="title">方案结构</div>
            <div class="imgs">
                <img src="~assets/image/solution-img/resolve2.png" alt="方案结构" />
            </div>
            <div class="title">方案功能</div>
            <div class="res-img">
                <img style="height: 380px;" src="~assets/image/solution-img/resolve3.png" alt="方案功能" />
            </div>
            <ul>
                <li>
                    <img src="~assets/image/solution-img/sy01.gif" alt />
                    <h3>入库管理</h3>
                    <p>通过机械化搬运、RFID数据采集</p>
                    <p>实现快速入库</p>
                    <p>精确统计货物及托盘信息</p>
                </li>
                <li>
                    <img src="~assets/image/solution-img/sy02.gif" alt />
                    <h3>上架管理</h3>
                    <p>识别、核对库位，记录库位信息</p>
                    <p>降低人为误差</p>
                    <p>精确统计货物及托盘信息</p>
                    <p>智能规划存储、拣货路线，提升</p>
                    <p>仓储效率</p>
                </li>
                <li>
                    <img src="~assets/image/solution-img/sy03.gif" alt />
                    <h3>盘点管理</h3>
                    <p>快速获取托盘信息，记录数据，</p>
                    <p>与数据库对比，核实库存数量</p>
                    <p>减少仓库停工时间</p>
                    <p>降低人为误差</p>
                </li>
                <li>
                    <img src="~assets/image/solution-img/sy04.gif" alt />
                    <h3>出库管理</h3>
                    <p>快速获取、核实货品信息</p>
                    <p>出库时通过门式RFID核对总数，</p>
                    <p>数据上传</p>
                    <p>提升拣货效率，减少人为失误</p>
                </li>
                <li>
                    <img src="~assets/image/solution-img/sy05.png" alt />
                    <h3>人员管理</h3>
                    <p>减少人工操作，降低操作难度</p>
                    <p>RFID读取时间统计，管理员工</p>
                    <p>工作效率</p>
                    <p>提升人员工作积极性</p>
                </li>
            </ul>
            <div class="title">客户受益</div>
            <div class="res-img">
                <img style="height: 380px;" src="~assets/image/solution-img/client.png" alt="客户受益" />
            </div>
            <div class="client">
                <ul>
                    <li>
                        <div class="client-img">
                            <img src="~assets/image/solution-img/clit01.png" alt="高效">
                        </div>
                        <div class="article">
                            <h3>高效</h3>
                            <p>信息化带托运输、机械化搬运、出、入库智能化核对——全流程的高效作业</p>
                        </div>
                    </li>
                    <li>
                        <div class="client-img">
                            <img src="~assets/image/solution-img/clit02.png" alt="精确">
                        </div>
                        <div class="article">
                            <h3>精确</h3>
                            <p>通过RFID标签智能化高效管理仓库操作环节,对货品及库位信息自动复核，避免人工操作的误差，数据信息精确。</p>
                        </div>
                    </li>
                    <li>
                        <div class="client-img">
                            <img src="~assets/image/solution-img/clit03.png" alt="管理">
                        </div>
                        <div class="article">
                            <h3>管理</h3>
                            <p>减少人工操作，降低员工操作难度通过芯片读取时间统计，管理员工工作效率，提升人员工作积极性。</p>
                        </div>
                    </li>
                    <li>
                        <div class="client-img">
                            <img src="~assets/image/solution-img/clit04.png" alt="循环">
                        </div>
                        <div class="article">
                            <h3>循环</h3>
                            <p>RFID芯片可多次读写、修改，托盘也可循环使用，非一次性托盘,节省成本，为全球环保做出贡献。</p>
                        </div>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.ancestor {
    background: #fff;
    width: 100%;
    margin-top: 30px;
    padding-bottom: 30px;
    .theme-titles {
        height: 55px;
        padding: 10px 30px;
        background: #fff;
        border-bottom: 5px solid #ff6000;
        font-size: 16px;
        .theme-text {
            float: left;
            width: 200px;
            > img {
                vertical-align: middle;
            }
            .boult {
                margin-left: 5px;
                font-weight: bold;
                color: #ff6000;
            }
            .theme-name {
                font-weight: bold;
                display: inline-block;
                // margin-top: 6px;
                margin-left: 12px;
            }
        }
    }
    .header {
        margin: 30px;
        > div {
            height: 50px;
            margin: 30;
            p {
                text-indent: 2em;
            }
        }
    }
    .sortware {
        margin-top: 20px;
        .title {
            width: 100%;
            height: 50px;
            background: #ff6000;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 24px;
        }

        .imgs {
            margin-left: 170px;
            img {
                width: 600px;
            }
        }
        ul {
            margin-top: 30px;
            height: 500px;
            li {
                list-style: none;
                width: 265px;
                height: 200px;
                text-align: center;
                float: left;
                margin: 5px;
                img {
                    width: 60px;
                    margin-top: 30px;
                }
            }
        }
        .client {
            ul {
                height: 360px;
                margin-left: 55px;
                li {
                    list-style: none;
                    float: left;
                    width: 370px;
                    height: 165px;
                    display: flex;
                    text-align: initial;
                    align-items: center;
                    .article {
                        margin-left: 10px;
                        h3 {
                            font-size: 22px;
                        }
                        p {
                            width: 280px;
                            margin-top: 10px;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
}
</style>